export default __webpack_public_path__ + "static/media/mainbanner.afc9ca09.png";